import {FeaturesEnum} from './featuresFlagEnum';
import {ProductEnum} from './productEnum';

export const TELEMEDICINE_URL_UPDATE_FEATURE_BY_HOST: Record<ProductEnum, FeaturesEnum> = {
	[ProductEnum.HAP]: FeaturesEnum.PORTAL_FEATURE_TELEMEDICINE_URL_UPDATE_HAP,
	[ProductEnum.CCG]: FeaturesEnum.PORTAL_FEATURE_TELEMEDICINE_URL_UPDATE_CCG,
	[ProductEnum.CLINIPAM]: FeaturesEnum.PORTAL_FEATURE_TELEMEDICINE_URL_UPDATE_CLINIPAM,
	[ProductEnum.GNDI_MINAS]: FeaturesEnum.PORTAL_FEATURE_TELEMEDICINE_URL_UPDATE_NDIMINAS,
	[ProductEnum.GNDI]: FeaturesEnum.PORTAL_FEATURE_TELEMEDICINE_URL_UPDATE_NDISP,
	[ProductEnum.NOTREDAME_SAUDE]: FeaturesEnum.PORTAL_FEATURE_TELEMEDICINE_URL_UPDATE_NDISP,
};
